import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Select from 'react-select'
import { useAuthState } from "../../Helper/Context";

export const ZoneNameCommanDDL = (props) => {
    const { ZoneNameID, setZoneNameID, Flag, data, IsPost, Language, StarMark, ApiFlag, ZoneLabel, ZoneValue, ByDefaultShowFlag,ZoneID,ZoneName } = props

    const { t } = useTranslation()

    const dispatch = useDispatch()
    const userDetails = useAuthState();
    const { UserID, token } = userDetails


    useEffect(() => {
        const data = {
            UserID: UserID,
            Lanaguage: Language?.Label,
            Flag: ApiFlag,
            token: token
        }
        if (Language.Label != null || Language.Label != undefined) {
            // dispatch(ZoneNameDDLAPI({ data }))
        }
    }, [IsPost, Language?.Label])

    // const { DDLData } = useSelector(state => state.ZoneNameDDLData)

    // useEffect(() => {
    //     handleDDL()
    // }, [DDLData])

    // const handleDDL = () => {
    //     if (DDLData && DDLData.table && DDLData.table.length > 0) {
    //         let list = DDLData.table.map((item, index) => ({
    //             value: item.m_ZoneID,
    //             label: item.zoneName,
    //         }))

    //         // setZoneNameID({
    //         //     DDL: list,
    //         //     ID: Flag == 'Update' ? data?.m_ZoneID : 0,
    //         //     Label: Flag == 'Update' ? data?.zoneName : "Select...",
    //         // })

    //         if (ByDefaultShowFlag == "ByDefaultShowFlag") {
    //             setZoneNameID({
    //                 DDL: list,
    //                 ID: data?.m_ZoneID,
    //                 Label: data?.zoneName
    //             })
    //         } else {
    //             setZoneNameID({
    //                 DDL: list,
    //                 ID: Flag === 'Update' ? data?.m_ZoneID : ZoneValue ? ZoneValue : ZoneID ? ZoneID : 0,
    //                 Label: Flag === 'Update' ? data?.zoneName : ZoneLabel ? ZoneLabel : ZoneName ? ZoneName : 'Select...'
    //             })
    //         }
    //     }
    //     else {
    //         setZoneNameID({
    //             DDL: [],
    //             ID: 0,
    //             Label: "Select...",
    //         })
    //     }
    // }
    return (
        <div className="form-group">
            <label for="fname" className=" pb-2">{t('EncroachmentDashboard.ZoneName')}</label>
            <Select
                id='ZoneNameID'
                isClearable={false}
                // isRtl={isRtl}
                isSearchable
                isDisabled={ByDefaultShowFlag == "ByDefaultShowFlag" ? "disabled" : ''}
                maxMenuHeight={130}
                value={{ value: ZoneNameID?.ID, label: ZoneNameID?.Label }}
                onChange={(e) => {
                    e ?
                        setZoneNameID({ ...ZoneNameID, ID: e.value, Label: e.label })
                        :
                        setZoneNameID({ ...ZoneNameID, ID: 0, Label: "Select..." })

                }}
                options={ZoneNameID?.DDL}
            />
        </div>
    )
}